import { useGlobalStore } from "@/store/GlobalStore";
import {
  OrderPaymentTypeCode,
  PaymentPurposeCode,
  PaymentTypeCode,
  QRCODE_QUERY_MAP,
  rechargeChannelsCode,
} from "project-config/constants";
import React, { useEffect, useMemo, useState } from "react";
import {
  LeftContent,
  RechargeContentWrapper,
  RechargeViewWrapper,
  RightContent,
} from "./atom";
import { useSearchParams } from "react-router-dom";
import request from "project-config/services/request/request";
import { handlePaycode } from "@/utils";
import { useUserPropertyStore } from "@/store2/userProperty/user-property-store";
import { useClientTopUpStore } from "../../store";
import { PictureNormalRecharge } from "../picture-normal-balance-recharge";
import { PictureRechargeGift } from "../picture-recharge-gift";
import { RechargeInputForm } from "../charge-input-form";
import { BindActivityInfo } from "@/components/top-up/types";
import { PaymentWay } from "../payment-way";
import {
  BalanceTipType,
  ExtraWelfareTipType,
  RechargeTips,
} from "../../help/tips";
import { payWithAli } from "@/components/top-up/help/payWithAli";
import { ClientSecondTabs } from "@/pages/client-top-up/components/client-second-tabs";
import { useToastStore } from "@/store/toast-store";
import { initVerifyRechargeInfo } from "../../constants";
import { useTranslation } from "react-i18next";

const Recharge: React.FC<{
  rechargeActivityList?: BindActivityInfo[];
}> = ({ rechargeActivityList }) => {
  const { showGlobalToast } = useToastStore();
  const { t } = useTranslation("topup");
  const rechargeActivity = rechargeActivityList?.[0];
  const [searchParams] = useSearchParams();
  const {
    rechargeAmount,
    rechargeSecondActiveName,
    setRechargeSecondActiveName,
    verifyRechargeInfo,
    setVerifyRechargeInfo,
  } = useClientTopUpStore();
  const [paying, setPaying] = useState(false);
  const { userInfo, currencySymbol } = useGlobalStore();
  const { userProperty } = useUserPropertyStore();
  const [balanceTip, setBalanceTip] = useState<BalanceTipType[]>();
  const [extraTip, setExtraTip] = useState<ExtraWelfareTipType[]>();

  const goal = useMemo(
    () =>
      rechargeSecondActiveName === "client-second-tab-first-recharge"
        ? PaymentPurposeCode.FirstRecharge
        : rechargeActivity
        ? PaymentPurposeCode.ActivityRecharge
        : PaymentPurposeCode.OrdinaryRecharge,
    [rechargeSecondActiveName, rechargeActivity]
  );

  const qrcodeLink = () => {
    let link = `&${QRCODE_QUERY_MAP.orderType}=${
      rechargeActivity ? OrderPaymentTypeCode.OrdinaryOrder : "1"
    }&${QRCODE_QUERY_MAP.amount}=${Number(rechargeAmount)}&${
      QRCODE_QUERY_MAP.rechargeGoal
    }=${goal}`;
    if (
      verifyRechargeInfo?.couponNO &&
      Number(rechargeAmount) >= verifyRechargeInfo?.rechargeAmount
    ) {
      link += `&${QRCODE_QUERY_MAP.couponNO}=${verifyRechargeInfo?.couponNO}`;
    }
    return link;
  };

  const onClickCantScanCode = async () => {
    setPaying(true);
    let agent = searchParams.get("agent") || "";
    let params = {
      agent: agent || "",
      currency: userInfo?.zone,
      payMethod: PaymentTypeCode.Alipay,
      amount: Number(rechargeAmount),
      rechargeGoal: goal,
      rechargeChannels: rechargeChannelsCode.Client,
    } as any;

    // 二次进行充值兑换判断
    if (
      verifyRechargeInfo?.couponNO &&
      Number(rechargeAmount) >= verifyRechargeInfo?.rechargeAmount
    ) {
      params = {
        ...params,
        couponNo: verifyRechargeInfo?.couponNO,
        couponActivityId: verifyRechargeInfo?.activityId,
      };
      const { code } = await request.post(
        "/api/rendering/pay/recharge/verifyRechargeCode",
        {
          couponNO: verifyRechargeInfo?.couponNO,
          amount: Number(rechargeAmount),
        }
      );
      if (code !== 200) {
        setVerifyRechargeInfo(initVerifyRechargeInfo);
        showGlobalToast({
          type: "error",
          content: t(`renderbus_coupon_code_tips_${code}`),
        });
        return;
      }
    }
    const { code, data } = await request.post(
      "/api/rendering/pay/recharge/addPayRecord",
      params
    );

    if (code !== 200) {
      setPaying(false);
      handlePaycode(code);
      return;
    }
    payWithAli(data.params, () => "todo modal");
    setPaying(false);
  };

  const getRechargeSecondTabList = () => {
    let list = [];
    list.push(
      rechargeActivity
        ? {
            label: rechargeActivity.activityName,
            key: "client-second-tab-activity-recharge",
            children: (
              <div>
                <PictureRechargeGift activityInfo={rechargeActivity} />
                <RechargeInputForm />
              </div>
            ),
          }
        : {
            label: "余额充值",
            key: "client-second-tab-balance-recharge",
            children: (
              <div>
                <PictureNormalRecharge />
                <RechargeInputForm />
              </div>
            ),
          }
    );
    // 取消效果图首充活动
    // if (userProperty?.isFirstRecharge === Whether.No) {
    //   list.unshift({
    //     label: "首充专享福利",
    //     key: "client-second-tab-first-recharge",
    //     children: <PictureFirstRecharge />,
    //   });
    // }
    return list;
  };

  useEffect(() => {
    const rechargeTips = new RechargeTips({
      amount: Number(rechargeAmount),
      userProperty,
      currencySymbol,
      activityInfo: rechargeActivity,
      rechargeSecondActiveName: rechargeSecondActiveName,
      verifyRechargeInfo: verifyRechargeInfo,
    });
    rechargeTips.init();
    setBalanceTip(rechargeTips.balanceTip);
    setExtraTip(rechargeTips.extraWelfareTip);
  }, [
    rechargeAmount,
    userProperty,
    currencySymbol,
    rechargeActivity,
    rechargeSecondActiveName,
    verifyRechargeInfo,
  ]);

  useEffect(() => {
    setRechargeSecondActiveName(getRechargeSecondTabList()[0].key);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userProperty]);

  return (
    <RechargeViewWrapper>
      <RechargeContentWrapper>
        <LeftContent>
          <ClientSecondTabs
            tabsList={getRechargeSecondTabList()}
            activeKey={rechargeSecondActiveName}
            onChange={(k) => {
              setRechargeSecondActiveName(k);
            }}
          />
        </LeftContent>
        <RightContent>
          <PaymentWay
            paying={paying}
            onClickCantScanCode={onClickCantScanCode}
            account={rechargeAmount}
            qrcodeLink={qrcodeLink()}
            balanceTip={balanceTip}
            extraTip={extraTip}
          />
        </RightContent>
      </RechargeContentWrapper>
    </RechargeViewWrapper>
  );
};
const RechargeView: React.FC<{
  rechargeActivityList?: BindActivityInfo[];
}> = ({ rechargeActivityList }) => (
  <Recharge rechargeActivityList={rechargeActivityList} />
);
export default RechargeView;
